/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import SafeLink from "components/commons/SafeLink";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

const downloadAppQr = `${WealthyEnv.CDN_URL}/articles/partner-scanner-new.png`;
const wealthyLogo = `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`;
const playStoreButton = `${WealthyEnv.CDN_URL}/articles/play-store-transparent.svg`;
const appStoreButton = `${WealthyEnv.CDN_URL}/articles/app-store-transparent.svg`;

const AppDownload = () => {
  return (
    <AppDownloadWrapper>
      {/* <LogoWrapper>
        <WealthyLogo
          alt="wealthy"
          src={wealthyLogo}
        />
      </LogoWrapper> */}
      <QrCodeImage
        alt="Download App QR Code"
        src={downloadAppQr}
      />
      <Tagline>
        <span>Get the Wealthy Partner App</span>
        <span className="light-text">To manage client wealth with ease</span>
      </Tagline>

      <AppLinks>
        <AppLinkItem href={WealthyEnv.PARTNER_APP_NEW_APPSTORE_LINK}>
          <LinkImage
            alt="app-store"
            src={appStoreButton}
          />
        </AppLinkItem>
        <AppLinkItem href={WealthyEnv.WEALTHY_PARTNERS_APP_LINK}>
          <LinkImage
            alt="play-store"
            src={playStoreButton}
          />
        </AppLinkItem>
      </AppLinks>
    </AppDownloadWrapper>
  );
};

const AppDownloadWrapper = styled.div`
  width: 45%;
  background-color: ${colors.secondary};
  text-align: center;
  padding: 4rem;
  font-family: Lato;

  @media (max-width: 768px) {
    display: none;
  }
`;

const LogoWrapper = styled.div`
  text-align: left;
`;

const WealthyLogo = styled.img`
  height: 25px;
`;

const Tagline = styled.h2`
  font-family: Lato;
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.6;
  padding: 3rem 0;
  color: ${colors.textGray};

  span {
    font-size: 2.4rem;
    font-weight: 400;
    display: block;
    color: ${colors.textBlack};
  }

  .light-text {
    font-size: 2rem;
    font-weight: 400;
    color: ${colors.textGray};
  }
`;

const QrCodeImage = styled.img`
  width: 145px;
  margin: 4rem 0 0;
`;

const AppLinks = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const AppLinkItem = styled(SafeLink)`
  display: inline-block;

  &:not(:last-child) {
    margin-right: 20px;
    @media (max-width: 576px) {
      margin-right: 20px;
    }
  }
`;

const LinkImage = styled.img`
  height: 38px;

  @media (max-width: 576px) {
    height: 30px;
  }
`;

export default AppDownload;
